import { types } from "../types/types"

const initialState = {
    loading: false,
    full_loading: false,
}

export const uiReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.uiStartLoading:
            return {
                ...state,
                loading: true,
            }
        case types.uiFinishLoading:
            return {
                ...state,
                loading: false,
            }
        case types.full_loading:
            return {
                ...state,
                full_loading: action.payload,
            }
        default:
            return state;
    }
}